import { hotTopics, categories } from "@/mocks/gossipData";

export default function Trending() {
  return (
    <section id="trending" className="wrap py-14 md:py-20">
      <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end">
        <div>
          <p className="mb-2 text-xs font-bold uppercase tracking-widest text-primary-600">TRENDING NOW</p>
          <h2 className="font-display text-2xl font-black text-foreground-950 md:text-4xl">
            今日热榜<span className="ml-2 align-middle text-base font-medium text-foreground-400">吃瓜不打烊</span>
          </h2>
        </div>
        <span className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-100 px-4 py-2 text-sm font-bold text-primary-700">
          <i className="ri-time-line"></i>实时更新 · {hotTopics.length} 条在榜
        </span>
      </div>

      <div className="mt-8 grid gap-8 lg:grid-cols-[1fr_360px]">
        {/* 左：热榜 */}
        <ol className="space-y-3">
          {hotTopics.map((t) => (
            <li key={t.rank}>
              <a
                href="#feed"
                className="group flex items-center gap-4 rounded-lg border border-transparent bg-background-100/60 p-3 transition hover:border-primary-200 hover:bg-background-50 md:p-4"
              >
                <span
                  className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-md font-display text-base font-black ${
                    t.rank <= 3
                      ? "bg-primary-500 text-background-50"
                      : t.rank <= 5
                        ? "bg-accent-500 text-foreground-950"
                        : "bg-background-200 text-foreground-600"
                  }`}
                >
                  {t.rank}
                </span>
                <div className="min-w-0 flex-1">
                  <p className="truncate text-sm font-medium text-foreground-900 group-hover:text-primary-700 md:text-[15px]">
                    {t.title}
                  </p>
                  <p className="mt-0.5 text-xs text-foreground-500">
                    <span className="inline-flex items-center gap-1 text-primary-600">
                      {t.up ? <i className="ri-arrow-up-line"></i> : <i className="ri-arrow-down-line text-foreground-400"></i>}
                      热度 {t.heat}
                    </span>
                  </p>
                </div>
                <span className="hidden shrink-0 whitespace-nowrap rounded-full bg-secondary-100 px-2.5 py-1 text-xs font-medium text-secondary-800 sm:inline-block">
                  {t.tag}
                </span>
              </a>
            </li>
          ))}
        </ol>

        {/* 右：风向标 */}
        <aside className="space-y-6">
          <div className="rounded-lg bg-primary-500 p-6 text-background-50">
            <h3 className="flex items-center gap-2 font-display text-lg font-bold">
              <i className="ri-radar-line"></i>话题风向标
            </h3>
            <p className="mt-3 text-sm font-light leading-relaxed text-background-100">
              综合全网讨论热度，为你标注此刻最值得围观的方向。榜单每 30 分钟自动刷新一次，蹭热更要趁早。
            </p>
            <dl className="mt-5 grid grid-cols-3 gap-3 border-t border-background-50/25 pt-4 text-center">
              <div>
                <dt className="text-xs text-background-200">日均话题</dt>
                <dd className="mt-1 font-display text-xl font-bold text-accent-300">126+</dd>
              </div>
              <div>
                <dt className="text-xs text-background-200">累计覆盖</dt>
                <dd className="mt-1 font-display text-xl font-bold text-accent-300">9800万</dd>
              </div>
              <div>
                <dt className="text-xs text-background-200">峰值热度</dt>
                <dd className="mt-1 font-display text-xl font-bold text-accent-300">#3</dd>
              </div>
            </dl>
          </div>

          <div className="rounded-lg bg-background-100 p-6">
            <h3 className="flex items-center gap-2 font-display text-lg font-bold text-foreground-900">
              <i className="ri-price-tag-3-line text-primary-600"></i>瓜田分类
            </h3>
            <ul className="mt-4 space-y-3">
              {categories.map((c) => (
                <li key={c.key}>
                  <a href="#feed" className="group flex items-center justify-between gap-3">
                    <span className="flex items-center gap-2 text-sm text-foreground-700 group-hover:text-primary-700">
                      <i className={`${c.icon} text-primary-500`}></i>
                      <span className="whitespace-nowrap">{c.label}</span>
                      <span className="text-xs text-foreground-400">· {c.subtitle}</span>
                    </span>
                    <i className="ri-arrow-right-line text-foreground-300 transition group-hover:translate-x-1 group-hover:text-primary-600"></i>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </aside>
      </div>
    </section>
  );
}